// -----------------------------------------------------------------------
// <copyright file="inputFields.ts" company="Microsoft">
//     copyright (c) Microsoft. All rights reserved.
// </copyright>
// -----------------------------------------------------------------------

export enum InputType {
  Text,
  Dropdown,
  TextArea,
  Checkbox,
}

export type InputField = {
  id: string;
  inputType: InputType;
  labelStringId: string;
  placeholderStringId?: string;
  options?: DropDownOption[];
  isRequired: boolean;
};

export type DropDownOption = {
  value: string;
  textStringId?: string;
  text?: string;
};
